import { IMicrofrontendManifest } from '@cian/mf-registry/shared';

interface IMicrofrontend {
  manifest: IMicrofrontendManifest;
}

export const prepareMicrofrontendManifest = <T extends IMicrofrontend>(response: T) => {
  return response.manifest;
};
